/// <amd-module name="Core/Medius.Core.Web/Scripts/components/sendEmailDialog/errorItem"/>
import { FlexLayout, IconStatusErrorRegular, Text } from "@medius/ui-controls";
import * as React from "react";

export enum PaddingSize {
    none = "0px",
    small = "4px", 
    normal = "8px",
    large = "16px",
    xlarge = "24px",
} 

export const ErrorItem = (props: {errorMessage: string, paddingSize?: PaddingSize}) => {
    return (
        <FlexLayout
            itemColumnSpacing="vsmall"
            wrapItems={false}
            verticalAlignment="top"
            style={{marginTop: props.paddingSize || PaddingSize.normal}}
        >
            <IconStatusErrorRegular color="error" />
            <Text
                variant="small"
                feedbackType="error"
            >
                {props.errorMessage}
            </Text>
        </FlexLayout>
    );
};
